import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import globalMixin from './mixins/global'
import * as utils from '@/utils'

import '@/assets/scss/main.scss'

Vue.mixin(globalMixin)
Vue.prototype.$utils = utils

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')